import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getQuizRequest, getQuizRequestError, getQuizRequestSuccess } from "../../../slices/teams/members/GetQuizSlice";

export const GetQuizApi = (currentPage,limit,searchTerm, categoryId) => async (dispatch) => {
    const queryParams = new URLSearchParams({ currentPage: currentPage, limit: limit,searchTerm:searchTerm,category_id:categoryId }).toString();

    const url = `${endpoints.QuizList}?${queryParams}`;
    try {
        dispatch(getQuizRequest());
        axiosInstance({
            method: "GET",
            url: url,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getQuizRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getQuizRequestError(_error));
            });
    } catch (error) { }
};
